<template>
  <AppModal :id="id" :size="size">
    <template v-slot:title>
      <h3 class="text-center mb-5">{{ $t($getConst.pages.scope.details) }} : {{log.id}} </h3>
    </template>
    <template v-slot:content>
      <pre v-if="detailsIsJsonString(log.details)">{{ JSON.parse(log.details) }}</pre>
      <template v-else>
        {{ log.details}}
      </template>
    </template>
    <template v-slot:button>
      <AppConfirmButtons :firstButton="false"
        @onCancel="close"
      />
    </template>
  </AppModal>
</template>

<script>
  import AppModal from "../../../../components/common/modals/AppModal";
  import AppConfirmButtons from "../../../../components/common/utils/AppConfirmButtons";

  export default {
    name: "ShowLogDetailsModal",
    components: {AppConfirmButtons, AppModal},
    props: {
      id: String,
      log: null,
      size: String
    },
    methods: {
      close() {
        this.$bvModal.hide(this.id);
        this.$emit('onCancel');
      },
      detailsIsJsonString(string) {
        try {
          JSON.parse(string);
        } catch (e) {
          return false;
        }
        return true;
      }
    }
  }
</script>

<style scoped>

</style>
